package one.primehealth.analytics.impl

import one.primehealth.analytics.AmplitudePlatform
import one.primehealth.analytics.AppAnalytics
import one.primehealth.analytics.events.AppEvent

internal class AmplitudeAppAnalytics(
    private val amplitude: AmplitudePlatform
) : AppAnalytics {
    override fun logEvent(event: AppEvent) {
        amplitude.logEvent(event)
    }
}